module.exports = __webpack_public_path__ + "static/media/SWGB-BNB.4359d6b5.svg";